import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { MarketplaceIllustration } from "@/components/illustrations/MarketplaceIllustration";
import { HomeSection } from "@/components/home/HomeSection";

export function HomeCtaBanner() {
  const { t } = useLang();
  const { user } = useAuth();
  const isAuthed = !!user && user !== false;

  return (
    <HomeSection tone="dark" testId="home-cta-banner">
      <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-12">
        <div className="text-center lg:text-left">
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-matpro-green">
            {t("home.cta_kicker")}
          </p>
          <h2 className="mt-2 font-heading text-3xl font-extrabold leading-tight text-white sm:text-4xl">
            {t("home.cta_title")}
          </h2>
          <p className="mx-auto mt-3 max-w-lg text-sm leading-relaxed text-zinc-400 sm:text-base lg:mx-0">
            {t("home.cta_subtitle")}
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3 lg:justify-start">
            <Button
              asChild
              className="h-11 rounded-xl bg-matpro-green px-6 font-semibold text-white hover:bg-matpro-green-dark"
            >
              <Link to={isAuthed ? "/profil" : "/inscription"}>
                {t("home.cta_register")}
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              className="h-11 rounded-xl border-white/30 bg-transparent font-semibold text-white hover:bg-white/10"
            >
              <Link to={isAuthed ? "/ma-boutique" : "/inscription"}>
                {t("home.cta_open_shop")}
              </Link>
            </Button>
          </div>
        </div>
        <div className="relative hidden h-[220px] lg:block xl:h-[260px]">
          <MarketplaceIllustration className="opacity-95" />
        </div>
      </div>
    </HomeSection>
  );
}
